module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Afiliação cadastrada com sucesso!","description":"Para definir a {acquirer} como sua adquirente, é necessário definir o status como ativo."},"en-US":{"title":"Affiliation successfully registered!","description":"To set {acquirer} as your acquirer, you need to set the status to active."}}')
  delete Component.options._Ctor
}
